import styled, { css } from "styled-components"
import { Link } from "react-scroll"
import Img from "gatsby-image"
import { T } from "../../design-system/styles/typography"
import Breakpoints from "../shared/breakpoints"

export const Title = styled.div`
  ${T.sm.h3`500`};
  text-align: left;

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h3`500`}
    text-align: center;
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h3`500`}
    text-align: left;
  }

  ${props => props.styleModifier}
`

export const PlatformBlocks = styled(Img)`
  @media (min-width: ${Breakpoints.sm}) {
    z-index: -10;
    grid-column: 2 / 12;
    grid-row: 1;
    margin-top: 32px;
  }

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 48px;
    grid-column: 1 / 6;
    grid-row: 1;
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 48px;
    grid-column: 2 / 6;
  }

`

export const FadedTitleWrapper = styled.div`
  text-align: center;
  grid-column: 2 / 12;
  grid-row: 2;
  margin-top: -68px;
  
  @media(min-width: ${Breakpoints.md}) {
    text-align: left;
    grid-column: 7 / -1;
    margin-top: 128px;
    grid-row: 1;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 7 / -1;
    margin-top: 208px;
  }
`

export const Orange = styled.span`
  color: var(--burnt-orange);
  font-weight: 500;
`

export const StyledFluid = styled(Img)`
  grid-column: 1 / -1;
  width: 100%;
  ${props => props.styleModifier}
`

export const visitorIntentImageStyle = css`
  grid-row: 4;
  margin-top: 32px;
  grid-column: 1 / -1 ;

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 48px;
    grid-column: 3 / -3;
    grid-row: 3;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 8 / -1;
    margin-top: 64px;
    grid-row: 2;
  }
`
export const missedSearchImageStyle = css`
  grid-row: 6;
  margin-top: 32px;
  grid-column: 1 / -1;

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 48px;
    grid-column: 3 / -3;
    grid-row: 5;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 7;
    grid-row: 3;
    margin-top: 96px;
  }
`
export const dataImageSrc = css`
  grid-row: 8;
  margin-top: 32px;
  grid-column: 1 / -1;

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 48px;
    grid-column: 3 / -3;
    grid-row: 7;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 7 / -1;
    grid-row: 4 / 6;
    margin-top: 120px;
    margin-bottom: 80px;
  }
`

export const DetailsWrapper = styled.div`
  width: 100%;
  text-align: left;
  align-self: center;
  align-items: center;

  @media (min-width: ${Breakpoints.md}) {
    text-align: center;
  }

  @media (min-width: ${Breakpoints.lg}) {
    text-align: left;
  }

  ${props => props.styleModifier}
`

export const visitorIntentStyle = css`
  grid-column: 1 / -1;
  text-align: left;
  grid-row: 3;
  margin-top: 64px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
    text-align: center;
    margin-top: 32px;
    grid-row: 2;
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 90px;
    grid-column: 2 / 7; 
  }
`

export const missedSearchesStyle = css`
  grid-column: 1 / -1;
  grid-row: 5;
  margin-top: 64px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / 12;
    margin-top: 96px;
    grid-row: 4;
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 64px;
    grid-column: 8 / -1;
    grid-row: 3;
  }
`

export const dataStyle = css`
  grid-column: 1 / -1;
  grid-row: 7;
  margin-top: 64px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
    margin-top: 96px;
    grid-row: 6;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 7;
    grid-row: 4;
    margin-top: 144px;
  }
`

export const DetailsBody = styled.p`
  color: var(--body-text-grey);
  margin-top: 24px;
  ${T.sm.body`300`}

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.body`300`}
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.body`300`}
    text-align: left;
  }
`

export const DemoLink = styled(Link)`
  cursor: pointer;
  ${T.misc.link`500`}
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 32px;
  text-decoration: none;
  text-align: center;
  box-sizing: border-box;
  background-color: var(--burnt-orange);
  color: var(--white);
  width: 100%;
  margin-top: 32px;
  margin-bottom: 64px;
  justify-self: center;
  grid-column: 2 / -2;
  grid-row: 9;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 4 / -4;
    max-width: 282px;
    grid-row: 8;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 5;
    margin-top: 48px;
    margin-bottom: 96px;
    grid-row: 5;
    justify-self: flex-start;
  }
`
